var _circle, _rect, _circle2, _circle3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeightGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#B8B8B8",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.625,
    y: 11.875,
    width: 28.7829,
    height: 26.25,
    rx: 5,
    fill: "#CCCCCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.637,
    cy: 31.7012,
    r: 3.60478,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4515,
    cy: 31.7012,
    r: 3.60478,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.041 23.1469C20.7792 23.1469 20.5322 22.9982 20.415 22.744L17.939 17.3804C17.8101 17.1015 17.8007 16.7769 17.9124 16.4908C18.0238 16.2064 18.2392 15.986 18.519 15.8707C20.5948 15.0135 22.7901 14.5786 25.0438 14.5786C27.2989 14.5786 29.4951 15.014 31.5713 15.8721C31.8508 15.9875 32.0658 16.207 32.1766 16.4905C32.2884 16.7753 32.2789 17.0989 32.1501 17.3774L29.6727 22.7441C29.5131 23.0884 29.117 23.2402 28.7664 23.0884C27.587 22.5769 26.3346 22.3177 25.0433 22.3177C24.7945 22.3177 24.5926 22.1158 24.5926 21.867C24.5926 21.6183 24.7945 21.4164 25.0433 21.4164C26.3904 21.4164 27.7005 21.6742 28.9389 22.1829L31.3315 17.0002C31.3675 16.9222 31.3509 16.8537 31.3374 16.8199C31.323 16.7825 31.2919 16.7325 31.2274 16.7059C29.2602 15.8925 27.1798 15.48 25.0437 15.48C22.9084 15.48 20.829 15.892 18.863 16.7041C18.7976 16.7312 18.7661 16.7821 18.7512 16.8199C18.7283 16.8784 18.73 16.9451 18.7567 17.0029L21.1479 22.1828C21.4963 22.0399 21.8546 21.9155 22.2147 21.8119C22.4549 21.7425 22.7037 21.8813 22.7722 22.1206C22.8411 22.3599 22.7027 22.6091 22.4634 22.6781C22.0758 22.7895 21.6914 22.9273 21.3201 23.0883C21.229 23.1279 21.134 23.1468 21.0406 23.1468L21.041 23.1469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0439 24.0427C25.0439 24.5405 24.6403 24.9441 24.1426 24.9441C23.6448 24.9441 23.2412 24.5405 23.2412 24.0427C23.2412 23.545 23.6448 23.1414 24.1426 23.1414C24.6403 23.1414 25.0439 23.545 25.0439 24.0427Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1416 24.4935C23.9397 24.4935 23.7563 24.357 23.7049 24.1518L21.9022 16.9411C21.8419 16.6999 21.9887 16.4553 22.2299 16.3948C22.4714 16.334 22.7162 16.4813 22.7765 16.7229L24.5792 23.9336C24.6396 24.1748 24.4927 24.4194 24.2512 24.4799L24.1416 24.4934L24.1416 24.4935Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightGrey);
export default __webpack_public_path__ + "static/media/weight_grey.167443473a04dd78408ab4f3b24e6200.svg";
export { ForwardRef as ReactComponent };